import React, { FC, ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { Prompt } from 'react-router-dom';
import { NavigationSteps } from '../../components/OfferDetails/OfferNavigation';
import CheckEligibilitySelector from '../../components/OfferEligibility/CheckEligibilitySelector';
import EligibilityHeader from '../../components/OfferEligibility/EligibilityHeader';
import EligibilityQualification from '../../components/OfferEligibility/EligibilityQualification';
import PackageSummary from '../../components/OfferEligibility/PackageSummary';
import StateSelector from '../../components/OfferEligibility/StateSelector';
import { isSessionExpired } from '../../redux/middleware';
import { RootState } from '../../redux/rootReducer';
import { OFFER_CONTACT_INFO_PATH } from '../../util/strings';
import {
  resetAllEligibilityOptions,
  resetNavigationStatus,
  setAllEligibilityOptions,
  // eslint-disable-next-line prettier/prettier
  setPreviousCalendarPosition
} from '../offerAvailability/offerAvailabilitySlice';
import {
  resetConfirmationError,
  resetPaymentContextErrorFlag,
  resetPaymentContextId,
  setPaymentButtonState,
  // eslint-disable-next-line prettier/prettier
  setPaymentcheckBox
} from '../offerConfirmation/offerConfirmationSlice';
import { setNavigationStep } from '../offerSearch/offerSearchSlice';
import { Prospect } from '../offerSearch/types';

const OfferEligibility: FC<any> = (props: any): ReactElement => {
  const prospect: Prospect | undefined = useSelector((state: RootState) => state.offerDetails.prospect);
  const searchparam = useSelector((state: RootState) => state.offerDetails.searchParameter);
  const customerExcludedStateCode = useSelector((state: RootState) => state.offerDetails.customerExcludedStateCode);
  const prospectState = prospect && prospect.stateProvince ? prospect.stateProvince : '';
  const [allCriteriaSelected, setAllCriteriaSelected] = useState<boolean>(false);
  const enableNextButton = allCriteriaSelected;
  const checkAllEligibilityOptions = useSelector(
    (state: RootState) => state.availabilityDates.allEligibilityOptionSelected,
  );
  const lastActiveTime = useSelector((state: RootState) => state.sessionManager).lastActiveTime;
  const dispatch = useDispatch();
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(setPreviousCalendarPosition());
    dispatch(setNavigationStep(NavigationSteps.OFFER_ELIGIBILITY));
    dispatch(resetNavigationStatus());
    dispatch(resetConfirmationError());
    dispatch(setPaymentButtonState(false));
    dispatch(setPaymentcheckBox(false));
    dispatch(resetPaymentContextId());
    dispatch(resetPaymentContextErrorFlag());
  }, [dispatch]);

  const onEligibilityCriteriaChange = (allChecked: boolean) => {
    dispatch(resetAllEligibilityOptions());
    setAllCriteriaSelected(allChecked);
  };

  const onNextClicked = () => {
    if (enableNextButton) {
      dispatch(setAllEligibilityOptions());
      props.history.push(OFFER_CONTACT_INFO_PATH);
    }
  };
  return (
    <>
      <div className="container">
        <Prompt when={true} message={() => !isSessionExpired(lastActiveTime)}></Prompt>
        <EligibilityHeader />
        <div className="row">
          <div className="col-sm-8">
            <StateSelector
              prospectState={prospectState}
              offerSearchMode={searchparam.mode}
              customerExcludedStateCode={customerExcludedStateCode}
            />
            <EligibilityQualification
              onSelectionChange={onEligibilityCriteriaChange}
              checkAllEligibilityOptions={checkAllEligibilityOptions}
            />
            <CheckEligibilitySelector enabled={enableNextButton} onClick={onNextClicked} />
          </div>
          <div className="col-sm-4">
            <PackageSummary />
          </div>
        </div>
      </div>
    </>
  );
};
export default withRouter(OfferEligibility);
